import { ICartProduct } from '@/store/ducks/order/types';
import { IProduct } from '@/store/ducks/products/types';

export const useCustomizeProduct = (
  item: ICartProduct | IProduct,
  quantity: number,
  customizationValue: string,
) => {
  if (!window.fbq) return;

  window.fbq('track', 'CustomizeProduct', {
    content_name: item.title,
    content_ids: [item.product_id],
    content_type: 'product',
    value: item.price * quantity,
    currency: 'BRL',
    quantity,
    contents: [customizationValue],
  });
};
